<template>
    <div :class="{'hidden': !cmOpener.isVisible(id)}" @click="cmOpener.close"
         class="z-10 fixed top-0 left-0 h-screen w-screen" ref="el">
        <div :style="cmOpener.style"
             :class="menuClass"
             ref="el_menu">
            <slot>
            </slot>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import { Watch } from 'vue-property-decorator/lib/decorators/Watch';

@Options({
    name:'ContextMenu',
    props: {
        visible: {
            type: Boolean,
            default: true
        },
        menuClass: {
            type: String,
            default: 'false'
        },
        cmOpener: {
            type: Object,
            required: true
        },
        id: {
            type: [String, Number],
            required: true
        },
    }
})
export default class ContextMenu extends Vue {
    id: any;
    cmOpener: any;

    @Watch('cmOpener.index')
    calcPosition(new_val: any, old_val: any) {
        if (this.cmOpener.isVisible(this.id)) {
            this.$nextTick(()=>this.cmOpener.refreshPosition(this.$refs.el_menu))
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
